export default "__VITE_PUBLIC_ASSET__fa36285a__"